module.exports = __webpack_public_path__ + "img/mock.bbd47f0b.png";